import React, { useState, useEffect } from "react";
import { RetriveServiceReportService } from "../../../../services/apiaddservice";
import {
  createQuotation,
  fetchAllServices,
  fetchPackages,
  getQuotationByUser,
  viewQuotation,
} from "../../../../services/apiService";
import {
  Edit2,
  Edit3,
  InfoIcon,
  Loader2,
  ScanEyeIcon,
  Trash2,
  TriangleAlert,
  X,
  XCircle,
} from "lucide-react";
import { getAdminProfile } from "../../../../services/authService";
import { showErrorToast, showSuccessToast } from "../../../../utils/toastUtils";
import IDSPayQuotation from "./DownloadQuotation";
import ViewQuotation from "../../../../components/modals/ViewQuotation";
import { useNavigate } from "react-router-dom";
import PreviewQuotation from "./PreviewQuotation";
import UpdateQuotationModal from "../../../../components/modals/UpdateModal";

const GenerateQuotationApi = () => {
  // State for form inputs
  const [billingType, setBillingType] = useState("1");
  const [monthlyVolume, setMonthlyVolume] = useState("")
  const [service, setService] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [ots, setOts] = useState("");
  const [wallets, setWallets] = useState([""]);
  const [selectedService, setSelectedService] = useState({});
  const [allPackages, setAllPackages] = useState([]);
  const [packageLoading, setPackageLoading] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false);
  // State for generated report
  const [report, setReport] = useState([]);
  const [page, setPage] = useState(0);
  const [quotationLoading, setQuotationLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [createQuotationId, setCreateQuotationId] = useState([]);
  const [updateQuotationId, setUpdateQuotation] = useState([]);
  const { allQuotation, setAllQuotation } = useState(null);
  const [previewClicked, setPreviewClicked] = useState(false);
  const [allReports, setAllReports] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [viewClicked, setViewClicked] = useState(false);
  const [editClicked, setEditClicked] = useState(false);
  const [viewsData, setViewsData] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [clientName, setClientName] = useState("");
  const [tempReport, setTempReport] = useState([]);
  const [generateClicked, setGenerateClicked] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const navigate = useNavigate();

  // const mockPrices = { Basic: "₹1.50", Pro: "₹2.50", Advanced: "₹4.00" };
  // Update wallet fields and packages when billing type changes

  const handlePackageChange = (e, bType) => {
    const values = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    if (bType === "2") {
      setSelectedPackages([values[0], values[1]]);
    } else if (bType === "3") {
      setSelectedPackages([values[0], values[1], values[2]]);
    } else {
      setSelectedPackages([values[0]]);
    }
  };

  const handleRemovePackage = (index) => {
    setSelectedPackages(selectedPackages.filter((_, idx) => idx !== index));
  };

  const handleWalletChange = (index, value) => {
    const newWallets = [...wallets];
    newWallets[index] = value;
    setWallets(newWallets);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // user reached bottom
    if (scrollHeight - scrollTop <= clientHeight + 5) {
      getAllServices();
    }
  };

  const handlePreview = () => {
    navigate("/QuotationPreview", {
      state: {
        clientName,
        ots,
        wallets,
        profileData,
        reportData: tempReport,
      },
    });
  };

  const handleGeneration = async () => {
    if (!selectedService?.id) {
      return showErrorToast("please select service");
    } else if (!clientName) {
      return showErrorToast("Please Enter Name");
    } else if (!selectedPackages.length > 0) {
      return showErrorToast("please select package");
    } else if (billingType === "1" && !ots && wallets[0] === "") {
      return showErrorToast("please enter topup amount or one time fee");
    } else if (
      billingType === "2" &&
      !ots &&
      (wallets[0] === "" || wallets[1] === "")
    ) {
      return showErrorToast("please enter two topup amount or one time fee");
    } else if (
      billingType === "3" &&
      !ots &&
      (wallets[0] === "" || wallets[1] === "" || wallets[2] === "")
    ) {
      return showErrorToast("please enter three topup amount or one time fee");
    } else if (
      billingType === "2" &&
      (selectedPackages.includes(null) ||
        selectedPackages.includes(undefined) ||
        selectedPackages.includes(""))
    ) {
      return showErrorToast("please select two packages");
    } else if (
      billingType === "3" &&
      (selectedPackages.includes(null) ||
        selectedPackages.includes(undefined) ||
        selectedPackages.includes(""))
    ) {
      return showErrorToast("please select three packages");
    }

    // setQuotationLoading(true);

    const tempData = {
      service_id: selectedService?.id,
      service_name: selectedService?.service_name,
      category: selectedService?.service_category?.name,
      billing_type: billingType,
      monthly_volume: monthlyVolume,
      searchInput,
      packages: selectedPackages,
      wallets: wallets,
      system_prices: selectedPackages?.map(
        (mainitem) =>
          allPackages?.find((item) => item?.package_id == mainitem)?.charge
            ?.amount,
      ),
    };

    setTempReport((prev) => [...prev, tempData]);
    setGenerateClicked(true);
  };

  const getAllServices = async () => {
    setServiceLoading(true);
    try {
      const res = await fetchAllServices({ page: page + 1 });

      if (res.status?.code === 200) {
        const { data, pagination } = res;
        setService((prev) => [...prev, ...res.data]);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setServiceLoading(false);
    }
  };

  const searchServices = async () => {
    setServiceLoading(true);
    try {
      const res = await fetchAllServices({ search: debouncedSearch });

      if (res.status?.code === 200) {
        setService(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setServiceLoading(false);
    }
  };

  const getPackages = async () => {
    setPackageLoading(true);
    try {
      const res = await fetchPackages({ service_id: selectedService?.id });

      if (res.status?.code === 200) {
        setAllPackages(res?.data);
      } else {
        setAllPackages([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPackageLoading(false);
    }
  };

  const getAllQuotationByUserId = async () => {
    try {
      const res = await getQuotationByUser({ user_id: profileData?.id });

      if (res?.status?.code === 200) {
        setAllReports(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (data, index) => {
    setWallets(data?.newWallets);
    setOts(data?.newOts);
    setClientName(data?.newClient);
    setTempReport((prev) => {
      const newArr = [...prev];
      newArr[index] = data?.tempData;
      return newArr;
    });
  };

  const handleDelete = (index) => {
    setTempReport(() => {
      const newArr = tempReport?.filter((_, idx) => idx !== index);
      return newArr;
    });
  };

  useEffect(() => {
    getAllServices();
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getAdminProfile();
        if (res?.data?.user_id) {
          setProfileData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching mobile number", error);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    if (!selectedService?.id) return;

    getPackages();
  }, [selectedService?.id]);

  useEffect(() => {
    if (!createQuotationId) return;

    if (report.some((item) => item?.quotation?.id === createQuotationId)) {
      return;
    }
    const fetchQuotation = async () => {
      try {
        const res = await viewQuotation({ quotation_id: createQuotationId });
        if (res?.status?.code === 200) {
          setReport((prev) => [...prev, res?.data]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchQuotation();
  }, [createQuotationId]);

  useEffect(() => {
    let count = 1;
    if (billingType === "2") count = 2;
    if (billingType === "3") count = 3;

    setWallets(new Array(count).fill(""));
    setSelectedPackages([]); // Reset packages on type change
  }, [billingType]);

  useEffect(() => {
    if (!profileData?.id) return;
    getAllQuotationByUserId();
  }, [profileData?.id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [searchInput]);

  useEffect(() => {
    searchServices();
  }, [debouncedSearch]);



  useEffect(() => {
    if (!generateClicked) return;

    const el = document.getElementById("scrollIntoView");

    el.scrollIntoView({ behavior: "smooth" });

    const timeout = setTimeout(() => {
      setGenerateClicked(false);
    }, 200);

    return () => {
      clearTimeout(timeout);
    };
  }, [generateClicked]);

  const maxPlans = Math.max(
    ...tempReport.map((item) => item?.system_prices?.length || 0),
  );

  return (
    <div className="bg-slate-50 min-h-screen p-4  font-sans text-slate-900">
      <div id="scrollIntoView" />
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        {/* <div className="mb-2 border-b pb-4">
          <h1 className="text-3xl font-black text-blue-900 italic">
            IDS<span className="text-green-500">Pay</span>{" "}
            <span className="text-slate-500 font-light not-italic">
              Quotation Generation Portal
            </span>
          </h1>
        </div> */}

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Form Section */}
          <div className="lg:col-span-1 bg-white p-6 rounded-2xl shadow-xl border border-slate-200 h-fit">
            <h2 className="text-lg font-bold mb-6 flex items-center text-slate-700">
              <i className="fas fa-cog mr-2 text-blue-600"></i> Configure Plan
            </h2>

            <div className="space-y-5">
              <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  1. Client Name <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="text"
                  value={clientName}
                  placeholder="Eg. IDSPay"
                  onChange={(e) => setClientName(e.target.value)}
                  className="w-full placeholder:pl-3 py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                />
              </div>
              <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  2. Billing Type{" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <select
                  value={billingType}
                  onChange={(e) => setBillingType(e.target.value)}
                  className="w-full p-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                >
                  <option value="1">Single Plan</option>
                  <option value="2">Two Plan</option>
                  <option value="3">Three Plan</option>
                </select>
              </div>

              <div>
                <label className=" text-xs font-bold uppercase tracking-wider flex items-center justify-between text-slate-500 ">
                  <div>
                    3. Search API Service{" "}
                    <span className="text-red-700 text-sm">*</span>
                  </div>
                  <div className="">
                    <Loader2
                      size={24}
                      className={`text-green-600 animate-spin ${serviceLoading ? "opacity-100" : "opacity-0"}`}
                    />
                  </div>
                </label>

                <div>
                  <input
                    type="search"
                    value={searchInput}
                    placeholder="Search Here..."
                    onChange={(e) => setSearchInput(e.target.value)}
                    className="w-full placeholder:pl-3 my-2 py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                  />
                </div>

                {service?.length > 0 ? (
                  <div className="w-full p-3 bg-slate-50 border border-slate-300 rounded-lg outline-none">
                    {/* <option value="">Select Service</option> */}

                    {service?.length > 0 && (
                      <div
                        onScroll={handleScroll}
                        className="max-h-60 flex flex-col px-4 items-start gap-1 overflow-y-auto"
                      >
                        {service?.map((item, idx) => (
                          <div
                            key={idx}
                            onClick={() => setSelectedService(item)}
                            className={`${selectedService?.service_code === item?.service_code ? "bg-blue-600 text-white" : ""} cursor-pointer py-1 w-full px-2 rounded-lg`}
                          >
                            {item?.service_name || "Not Found"}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full p-1 text-red-600 text-center rounded-lg outline-none flex items-center justify-center gap-3">
                    <TriangleAlert size={18} />
                    {searchInput} Not Found
                  </div>
                )}
              </div>

              <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  4. Select Package(s){" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <select
                  multiple={billingType !== "1"}
                  value={selectedPackages}
                  onChange={(e) => handlePackageChange(e, billingType)}
                  className="w-full p-3 bg-slate-50 border border-slate-300 rounded-lg outline-none "
                >
                  {packageLoading && <option value="">Loading...</option>}
                  <option disabled value="">
                    Select Package
                  </option>
                  {allPackages?.map((item, idx) => (
                    <option key={idx} value={item.package_id}>
                      {item?.package_name}
                    </option>
                  ))}
                </select>
                <p className="text-[10px] text-slate-400 mt-1 italic">
                  {billingType === "single"
                    ? "Select one package."
                    : "Hold Ctrl/Cmd to select multiple."}
                </p>

                {selectedPackages.length > 0 &&
                  !selectedPackages.includes(null || undefined || "") && (
                    <div className="flex gap-2 mt-2 flex-wrap">
                      {selectedPackages.map((item, idx) => {
                        if (item === null || item === "" || item === undefined)
                          return null;

                        const pkg = allPackages.find(
                          (ap) => ap.package_id == item,
                        );

                        return (
                          <button
                            onClick={() => handleRemovePackage(idx)}
                            className="flex justify-center items-center gap-2 py-2 hover:bg-rose-100 hover:text-rose-700 hover:border-rose-700 bg-green-100 rounded-full px-2 text-xs border border-green-700 text-green-700"
                          >
                            <span className="flex justify-center items-center gap-2">
                              {pkg?.package_name}{" "}
                              <p>{`₹${pkg?.charge?.amount}`}</p>
                            </span>
                            <span>
                              <XCircle size={16} />
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  )}
              </div>

                <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  5. Monthly Volume<span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="text"
                  value={monthlyVolume}
                  placeholder="Eg. 5"
                  onChange={(e) => setMonthlyVolume(e.target.value)}
                  className="w-full placeholder:pl-3 py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                />
              </div>

              <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  6. OTS (One Time Setup Fee)
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-3 text-slate-400">
                    ₹
                  </span>
                  <input
                    type="number"
                    value={ots}
                    onChange={(e) => setOts(e.target.value)}
                    placeholder="25000"
                    className="w-full p-3 pl-8 bg-slate-50 border border-slate-300 rounded-lg outline-none"
                  />
                </div>
              </div>

              <div>
                <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  7. Wallet Topup Amount
                </label>
                <div className="space-y-3">
                  {wallets.map((wallet, idx) => (
                    <div key={idx} className="relative">
                      <span className="absolute left-3 top-3 text-slate-400 text-xs font-bold">
                        Plan {idx + 1}
                      </span>
                      <input
                        type="number"
                        value={wallet}
                        onChange={(e) =>
                          handleWalletChange(idx, e.target.value)
                        }
                        placeholder="Enter Amount"
                        className="w-full p-3 pl-16 bg-white border border-slate-200 rounded-lg text-sm outline-none focus:border-blue-500"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={handleGeneration}
                disabled={quotationLoading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:-translate-y-1"
              >
                {quotationLoading ? (
                  <div className="w-full flex justify-center">
                    {" "}
                    <Loader2 className="text-white animate-spin" />
                  </div>
                ) : (
                  "Generate Quotation"
                )}
              </button>
            </div>
          </div>

          {/* Table Preview Section */}
          <div className="lg:col-span-2 bg-white p-8 rounded-2xl shadow-xl border border-slate-200">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-black text-slate-800 uppercase tracking-tight">
                Quotation Table Preview
              </h2>
              <span className="text-xs text-slate-400">
                {report?.timestamp}
              </span>
            </div>

            <div className=" overflow-y-auto  max-h-[450px]">
              <table className="w-full  border-collapse border border-slate-200 text-sm">
                <thead>
                  <tr className="bg-slate-800 text-white">
                    <th className="p-4 border border-slate-700 text-left">
                      Category
                    </th>
                    <th className="p-4 border border-slate-700 text-left">
                      Service Name
                    </th>
                    <th className="p-4 border border-slate-700 text-left">
                      Monthly Volume
                    </th>

                    {/* {wallets?.map((_, idx) => (
                      <th className="p-4 border border-slate-700 text-left">
                        Package {idx + 1}
                      </th>
                    ))} */}

                    {/* <th className="p-4 border border-slate-700 text-right">
                      Pricing (Plan 1)
                    </th>
                    <th className="p-4 border border-slate-700 text-right">
                      Pricing (Plan 2)
                    </th>
                    <th className="p-4 border border-slate-700 text-right">
                      Pricing (Plan 3)
                    </th> */}

                    {Array.from({ length: maxPlans }).map((_, idx) => (
                      <th
                        key={idx}
                        className="p-4 border border-slate-700 text-right"
                      >
                        Pricing (Plan {idx + 1})
                      </th>
                    ))}

                    {Array.from({ length: maxPlans }).length === 2 && (
                      <th className="p-4 border border-slate-700 text-left"></th>
                    )}
                    {Array.from({ length: maxPlans }).length === 1 && (
                      <>
                        <th className="p-4 border border-slate-700 text-left"></th>
                        <th className="p-4 border border-slate-700 text-left"></th>
                      </>
                    )}

                    <th className="p-4 border border-slate-700 text-left">
                      Editing
                    </th>

                    <th className="p-4 border border-slate-700 text-left">
                      Deletion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!tempReport ? (
                    <tr>
                      <td
                        colSpan="5"
                        className="p-10 text-center text-slate-400 italic"
                      >
                        No data selected. Configure the form and click Generate.
                      </td>
                    </tr>
                  ) : (
                    <>
                      {tempReport?.map((item, idx) => (
                        <tr className="hover:bg-slate-50 transition">
                          <td className="p-4 border border-slate-200 font-bold text-blue-800">
                            {item?.category}
                          </td>
                          <td className="p-4 border border-slate-200 font-bold text-blue-800">
                            {item?.service_name}
                          </td>
                          <td className="p-4 border border-slate-200 font-bold text-blue-800">
                            {item?.monthly_volume}
                          </td>

                          {item?.system_prices?.map((plan, i) => {
                            return (
                              <td
                                key={i}
                                className={`p-4 border border-slate-200 text-right font-mono font-bold text-green-600 ${item ? "text-green-600" : "text-red-600"}`}
                              >
                                {`₹${plan}`}
                              </td>
                            );
                          })}

                          {item?.system_prices?.length === 1 && (
                            <>
                              <td className="p-4 border border-slate-200 font-bold text-blue-800"></td>
                              <td className="p-4 border border-slate-200 font-bold text-blue-800"></td>
                            </>
                          )}
                          {item?.system_prices?.length === 2 && (
                            <>
                              <td className="p-4 border border-slate-200 font-bold text-blue-800"></td>
                            </>
                          )}

                          <td className="p-4 border font-bold ">
                            <button
                              className="bg-amber-100 px-4 py-1 border text-amber-700 border-amber-700 rounded-lg "
                              type="button"
                              onClick={() => {
                                setEditClicked(true);
                                setEditIndex(idx);
                              }}
                            >
                              <Edit3 size={18} />
                              {/* Edit */}
                            </button>
                          </td>

                          <td className="p-4 border font-bold ">
                            <button
                              className="bg-rose-100 px-4 py-1 border text-rose-700 border-rose-700 rounded-lg "
                              type="button"
                              onClick={() => handleDelete(idx)}
                            >
                              <Trash2 size={18} />
                              {/* Delete */}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            {tempReport?.length > 0 && (
              <div className="flex items-center mt-4 justify-between">
                <div className="w-full mt-4 text-sm flex justify-start gap-4">
                  <div className="flex justify-center items-center">
                    One time fee - {`₹${ots}`}
                  </div>
                  <span className="text-amber-600 text-2xl">|</span>
                  <div className="flex justify-center items-center gap-3">
                    Wallets{"-"}
                    {wallets?.map((item, idx) => (
                      <span key={idx}>{`₹${item || "-"}`}</span>
                    ))}
                  </div>
                </div>

                <div className="flex w-full justify-end ">
                  <button
                    onClick={() => setPreviewClicked(true)}
                    className="bg-blue-600 hover:bg-blue-700 flex justify-center items-center gap-2 text-white font-medium py-2 px-6 rounded-lg transition-colors duration-200"
                  >
                    <ScanEyeIcon />
                    See Preview
                  </button>
                </div>
              </div>
            )}

            {profileData && tempReport?.length > 0 && (
              <div className="max-w-sm mt-10 mx-auto overflow-hidden bg-white border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="p-6">
                  <p className="text-xs font-semibold tracking-wider text-blue-600 uppercase mb-4">
                    Quotation Generated By
                  </p>

                  <div className="space-y-3">
                    {/* Name */}
                    <h3 className="text-xl font-bold text-slate-800">
                      {profileData?.name}
                    </h3>

                    {/* Contact Info */}
                    <div className="flex flex-col gap-2 text-sm text-slate-600">
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-4 h-4 text-slate-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                        <span className="truncate">
                          {profileData?.email_address}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-4 h-4 text-slate-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                        <span>{profileData?.mobile_number}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Subtle footer accent */}
                <div className="h-1 w-full bg-gradient-to-r from-blue-400 to-indigo-500" />
              </div>
            )}
          </div>
        </div>
      </div>

      {allReports?.quotations?.length > 0 && (
        <div className="w-full relative">
          <div className="mt-6 w-full overflow-x-auto overflow-y-auto max-h-[500px] rounded-xl border border-gray-200 shadow-sm">
            <table className="min-w-[700px]  h-full w-full text-xs text-left text-gray-700">
              <thead className="bg-gradient-to-r from-cyan-600 to-blue-600 text-gray-100 uppercase tracking-wider sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3">Service Name</th>
                  <th className="px-4 py-3">Billing Type</th>
                  <th className="px-4 py-3">One Time Fee</th>
                  <th className="px-4 py-3">Plan 1</th>
                  <th className="px-4 py-3">Plan 2</th>
                  <th className="px-4 py-3">Plan 3</th>
                  <th className="px-4 py-3">View</th>
                  <th className="px-4 py-3">Created At</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100 bg-white">
                {allReports?.quotations?.map((item, index) => (
                  <tr
                    key={item.quotation?.id}
                    className={`hover:bg-gray-50 ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                    }`}
                  >
                    <td className="px-4 py-3 font-medium">
                      {item.quotation?.service_name}
                    </td>

                    <td className="px-4 py-3 text-left">
                      {item.quotation?.billing_type}
                    </td>

                    <td className="px-4 py-3">
                      {item.quotation?.one_time_setup_fee || "-"}
                    </td>

                    <td className="px-4 py-3">
                      {item.quotation?.plans[0]?.final_price || "-"}
                    </td>
                    <td className="px-4 py-3">
                      {item.quotation?.plans[1]?.final_price || "-"}
                    </td>
                    <td className="px-4 py-3">
                      {item.quotation?.plans[2]?.final_price || "-"}
                    </td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => {
                          setViewsData(item);
                          setViewClicked(true);
                        }}
                        className="bg-blue-50 text-blue-600 border border-blue-400 rounded-md py-1 px-2"
                      >
                        View
                      </button>
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap">
                      {new Date(item.quotation?.created_at).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {previewClicked && (
        <div className="fixed z-[99] inset-0 w-full bg-black overflow-y-auto h-screen">
          <button
            onClick={() => setPreviewClicked(false)}
            className="fixed top-10 z-[999] right-6 text-white"
          >
            <X size={40} className="bg-red-50 text-red-700 rounded-full p-1" />
          </button>
          <PreviewQuotation
            clientName={clientName}
            ots={ots}
            wallets={wallets}
            profileData={profileData}
            reportData={tempReport}
          />
        </div>
      )}

      <ViewQuotation
        isOpen={viewClicked}
        data={viewsData}
        onClose={() => {
          setViewsData(null);
          setViewClicked(false);
        }}
      />

      <UpdateQuotationModal
        isOpen={editClicked}
        onClose={() => setEditClicked(false)}
        index={editIndex}
        data={tempReport}
        editTempReport={handleEdit}
        allWallets={wallets}
        oneTimeFee={ots}
        client={clientName}
        oldService={selectedService}
      />
    </div>
  );
};

export default GenerateQuotationApi;
